<template>
  <div class="login">
    <Header></Header>
    <div class="ctn_box">
      <div class="form_ctn_center pa-5">
        <h1 class="form_ctn_title">Iniciar sesión</h1>
        <div class="old__pass"></div>
        <v-text-field
          autofocus
          type="email"
          color="#42a5f5"
          :rules="emailRules"
          label="Correo electrónico"
          outlined
          v-model="email"
        ></v-text-field>
        <v-text-field
          color="#42a5f5"
          :rules="rulesPass"
          label="Contraseña"
          outlined
          type="password"
          v-model="password"
        ></v-text-field>
        <div class="ctn_signin">
          <v-btn @click="autenticate()" class="btn_sign">INICIAR</v-btn>
          <p class="line"></p>
          <!-- <v-btn class="btn_reset" text tile to="/recovery"
            >¿Olvido su contraseña?</v-btn
          > -->
        </div>
        <!-- <div class="register_new">
          <p>¿Nuevo en Lubumas? obtenga <b>30 días</b> gratis,</p>
        </div> -->
        <v-alert class="alert-md" color="red" text v-if="errmensaje">{{
          errmensaje
        }}</v-alert>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import axios from "axios";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "Login",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      email: "",
      emailRules: [
        (v) => !!v || "El correo electrónico es requerido.",
        (v) =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "El formato no es valido",
      ],
      password: "",
      rulesPass: [(v) => !!v || "La contraseña es requerida."],
      errmensaje: null,
    };
  },
  methods: {
    autenticate() {
      const params = new URLSearchParams();
      params.append("email", this.email);
      params.append("password", this.password);
      axios
        .post("user/login", params)
        .then((response) => {
          return response.data;
        })
        .then((data) => {
          this.$store.dispatch("saveToken", data.token);
          this.$router.push({ path: `/panel/` });
        })
        .catch((error) => {
          this.errmensaje = null;
          if (error.response.status == 404) {
            this.errmensaje = "Usuario y/o contraseña invalidos";
          } else {
            this.errmensaje = "Ops! ocurrio un error con el servidor";
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/base.scss";
.login {
  height: 100%;
  background: $bg-light;
  //background-image: url('~@/assets/img/cityBgGray.png');
  //background-position: bottom center;
  //background-size: contain;
}
.ctn_box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 70px);
  padding: 70px 0 50px;
}
.form_ctn_center {
  width: 360px;
  h1.form_ctn_title {
    text-align: center;
    font-weight: bold;
    margin-bottom: 30px;
  }
  .ctn_signin {
    p.line {
      padding-top: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid #ddd;
    }
    .btn_sign {
      width: 100%;
      background: $green-btn;
      color: #fff;
    }
    .btn_reset {
      float: right;
      text-transform: unset;
      color: $blue-btn;
      font-size: 1rem;
      letter-spacing: 0;
      font-weight: normal;
    }
  }
}
</style>
